import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CCLocation } from '../../../../models/locations-models/cc-location';
import { GbpLocationGroup } from '../../../../models/locations-models/gbp-location-group';
import { CC_OPERATIONS, CCRowSetting } from '../../../../models/locations-models/cc-row-setting';
import { SortingEnum } from '../../enums/sorting-enum';
import {
      CCMatrixRequestPayload,
      CCMatrixResponsePayload,
} from '../../../../models/locations-models/cc-matrix-payload';
import { HttpErrorResponse } from '@angular/common/http';

// CC list
export const CCListRefreshActions = createActionGroup({
  source: 'CC-LIST REFRESH',
  events: {
    updateCCList: emptyProps(),
    requestNewCCMatrix: props<{ payload: CCMatrixRequestPayload }>(),
    processCCMatrix: props<{
      payload: CCMatrixResponsePayload,
      focusedLocationId: number // location which had been focused at the time the request was issued
    }>(),
    updateCCListSuccess: props<{ focusedLocationId: number,
      ccLocations: CCLocation[],
      lscLocationIdsToBeSelected?: number[]
    }>(),
    updateCCListError: props<{ focusedLocationId: number }>(),
    showUpdateCCListErrorSnackbar: props<{ payload: CCMatrixRequestPayload, error: HttpErrorResponse }>(),
    updateCCLocationsLoading: props<{ focusedLocationId: number, loading: boolean }>(),
    patchLocation: props<{ focusedLocationId: number, ccLocation: CCLocation }>(), // single CCLocation store update
  }
});

export const CCRowActions = createActionGroup({
  source: 'CC-LIST - ROW OPERATION',
  events: {
    setCcRowSettings: props<{ focusedLocationId: number, ccRowSettings: CCRowSetting[] }>(),
    updateCcRowSetting: props<{ focusedLocationId: number, ccRowSetting: CCRowSetting }>(),
    updateManyCcRowSettings: props<{ focusedLocationId: number, ccRowSettings: CCRowSetting[] }>(),
  }
})

export const CCActionBarActions = createActionGroup({
  source: 'CC-LIST - ACTION BAR',
  events: {
    updateCCLocationGroup: props<{ ccLocationGroup: GbpLocationGroup }>(),
    updateCCRadius: props<{ ccSearchRadius: number }>(),
    updateCCRadiusSuccess: props<{ ccSearchRadius: number }>(),
    updateCCKeywords: props<{ ccKeywords: string[] }>(),
    updateCCKeywordsSuccess: props<{ ccKeywords: string[] }>(),
    updateContinueAfterClaim: props<{ continueAfterClaim: boolean }>(),
    updateContinueAfterCreate: props<{ continueAfterCreate: boolean }>(),
  }
})

export const CCOperationActions = createActionGroup({
  source: 'CC-LIST CC-OPERATION',
  events: {
    ccOperation: props<{
      focusedLocationId: number,
      ccRowSetting: CCRowSetting,
      ccOperation: CC_OPERATIONS,
      starredState?: boolean
    }>(),
    ccOperationSuccess: props<{ focusedLocationId: number,
      ccRowSetting: CCRowSetting,
      ccOperation: CC_OPERATIONS }>(),
    ccOperationError: props<{ focusedLocationId: number,
      ccRowSetting: CCRowSetting }>(),
  }
});

export const updateCCListSorting = createAction('[CC-LIST] Update CC list sorting',
    props<{ sorting: SortingEnum }>());
// dispatch after an action the might invalidate cached CC results
export const markAllCCListsAsStale = createAction('[CC-LIST] Mark all cached CC location lists as potentially out-of-date');
// reset CC cache on account switch
export const resetCCData = createAction('[CC-LIST] Reset CC Data');
export const noop = createAction('[CC-LIST] noop');
